export const LS_JOB_SEARCH_QUERY = 'jobSearchQuery';
export const LS_SERVICE_WORK = 'serviceWorkModal_13.12.2023';